import Button from 'components/button';
const InvitationNotificationSection = ({ dataCreateMission, setPage }) => (
  <div className="mx-6 border-b border-gray-200 py-2">
    <div className="flex justify-between">
      <span className="ft-b text-gray-900 font-medium">
        Invitation / Notification
      </span>
      <Button color="DEFAULT" size="SM" onClick={() => setPage(4)}>
        Modifier
      </Button>
    </div>
    <div className="flex flex-col gap-4 ft-sm">
      <div className="flex flex-col">
        <span className="text-gray-900 font-medium">
          Intérimaires invités :
        </span>{' '}
        {dataCreateMission.users_invite &&
        dataCreateMission.users_invite.length > 0
          ? dataCreateMission.users_invite.map((tmp, i) => (
              <span key={i} className="mt-0.5">
                - {tmp.name}
              </span>
            ))
          : 'Aucun'}
      </div>
      <div className="flex flex-col">
        <span className="text-gray-900 font-medium">Intérimaire assigné :</span>{' '}
        {dataCreateMission.user_assigned && dataCreateMission.user_assigned._id
          ? `${dataCreateMission.user_assigned.lastname} ${dataCreateMission.user_assigned.firstname}`
          : 'Aucun'}
      </div>
      <div className="flex flex-col">
        <p className="ft-sm">
          <span className="text-gray-900 font-medium">
            Type de notification :
          </span>{' '}
          {dataCreateMission.inviteType === 'vivier'
            ? 'Vivier'
            : dataCreateMission.inviteType === 'global'
            ? 'Globale'
            : '-'}
        </p>
        {dataCreateMission.inviteType === 'vivier' &&
          dataCreateMission.vivierSelections &&
          dataCreateMission.vivierSelections.length > 0 && (
            <div className="flex flex-col ft-sm">
              <span className="text-gray-900 font-medium">
                Viviers sélectionnés :
              </span>
              {dataCreateMission.vivierSelections.map((sel, idx) => (
                <span key={idx} className="mt-0.5">
                  - {sel.name}
                </span>
              ))}
            </div>
          )}
      </div>
    </div>
  </div>
);

export default InvitationNotificationSection;
